<template>

  <div
    class="feed-content"
    :class="{'box-loading': loading}">
    
    <div
      class="photo"
      v-if="!edit">
      <Avatar
        :src="imgSrc"
        :name="activity.candidate.name"
        size="40px"
        radius="20px"
        resize="100x100x1" />
    </div>

    <div
      class="content"
      v-if="!edit">

      <div
        v-if="permissions.includes('manage_candidates')"
        class="feed-actions dropdown">
        <button
          class="btn btn-sm btn-light"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false">
          <i class="fas fa-chevron-down" />
        </button>
        <div class="dropdown-menu dropdown-menu-right">
          <button
            v-if="activity.questionnaire.type === 'test'"
            class="dropdown-item"
            @click="editQuestionnaire(activity.questionnaire)">
            <i class="fas fa-pencil-alt" /> {{ $t('Edit scores') }}
            </button>
          <button
            class="dropdown-item"
            @click="deleteQuestionnaire(activity.questionnaire._id)">
            <i class="fas fa-times" /> {{ $t('Remove') }}
            </button>
        </div>
      </div>

      <div>
        Questionário <strong>{{ activity.questionnaire.name }}</strong> respondido
      </div>
      
      <div
        v-if="activity.questionnaire.type === 'test'"
        class="mt-2">
        <strong>{{ $t('Note') }}:</strong>
        {{ activity.questionnaire.score }}/{{ activity.questionnaire.score_weight }} ({{ activity.questionnaire.score_percent }}%)
      </div>

      <div
        v-if="showAll"
        style="clear: both;"
        class="card mt-2">
        <QuestionnairePersonality
          :questionnaire="activity.questionnaire" />

        <div v-if="!isPersonalityTest">
          <div
            v-for="(question, index) in activity.questionnaire.questions"
            :key="index">
            <div class="card-header">
              <div class="d-flex">
                <div class="w-100 pr-3">
                  <div style="white-space: pre-wrap;">{{ question.label }}</div>
                  <div
                    v-if="question.image_media_id"
                    class="mt-2">
                    <img
                      :src="imageResizeUrl + encodeURIComponent(question.image_media_id.url)"
                      style="max-width: 520px; width: 100%;">
                  </div>
                </div>
                <div
                  v-if="activity.questionnaire.type === 'test'"
                  class="text-nowrap">
                  {{ $t('Note') }}: {{ question.score }}/{{ question.score_weight }}
                </div>
              </div>
            </div>
            <div
              v-if="question.type === 'text'"
              class="card-body">
              {{ question.answer }}
            </div>
            <div
              v-if="question.type === 'textarea'"
              class="card-body">
              <div style="white-space: pre-wrap;">{{ question.answer }}</div>
            </div>
            <div
              v-if="question.type === 'file'"
              class="card-body">
              <a
                v-if="question.answer_media_id"
                :href="question.answer_media_id.url"
                target="_blank">
                {{ question.answer_media_id.title }}
                </a>
            </div>
            <ul
              v-if="['radio', 'checkbox', 'mostleast'].includes(question.type)"
              class="list-group list-group-flush">
              <li 
                class="list-group-item" 
                v-for="(option, index) in question.options"
                :key="index" 
                :class="checkChoice(option, question.answer, question.answers, activity.questionnaire.type)">
                {{ option.title }}

                <strong
                  v-if="question.type === 'mostleast' && question.answers.includes(option.title)">
                  ({{ question.answers[0] === option.title ? 'Most' : 'Least' }})
                </strong>

                <span class="badge badge-success" v-if="option.correct">{{ $t('Correct') }}</span>
              </li>
            </ul>
          </div>
        </div>

      </div>

      <div class="mt-2">
        <a
          href="javascript:void(0)"
          @click="showAll=!showAll">
          {{ showAll ? $t('Show less') : $t('Show more') }}
          </a>
      </div>  

      <div class="mt-2">
        <small>
          <span
            v-tooltip="$d(new Date(activity.created_at), 'long')">
            {{ $d(new Date(activity.created_at), 'short') }}
            </span>
          <span>
            -
            </span>
          <router-link
            class="link-discreet"
            :to="{path: '/job/' + activity.job._id }">
            {{ activity.job.title }}
            </router-link>
        </small>        
      </div>
    </div>

    <div
      class="content"
      v-if="edit">
      <candidate-questionnaire-form
        :initValue="edit"
        @updated="updatedQuestionnaire"
        @cancel="editCancel">
        </candidate-questionnaire-form>  
    </div>
  </div>

</template>

<script>
import config from '@/config'
import CandidateQuestionnaireForm from '../Questionnaire/CandidateQuestionnaireForm'
import QuestionnairePersonality from '@/components/Questionnaire/QuestionnairePersonality'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'CandidateFeedQuestionnaireItem',
  components: {
    CandidateQuestionnaireForm,
    QuestionnairePersonality,
    Avatar
  },
  props: [
    'activity'
  ],
  data () {
    return {
      loading: false,
      edit: false,
      showAll: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    imageResizeUrl () {
      return `${config.modfile_url}image/520x520x0/`
    },
    isPersonalityTest () {
      return this.activity.questionnaire && this.activity.questionnaire.key
    },
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.activity.candidate.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    }
  },
  created () {
  },
  methods: {
    editQuestionnaire (data) {
      this.edit = data
    },
    editCancel () {
      this.edit = false
    },
    updatedQuestionnaire () {
      this.$store
      .dispatch('getActivities', {
        _id: this.activity._id
      })
      .then(() => {
        this.edit = false
      })
    },
    deleteQuestionnaire (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteQuestionnaire', id)
        .then((result) => {
          return this.$store.dispatch('deleteActivity', this.activity._id)
        })
        .then((result) => {
          this.loading = false
          this.$emit('deleted', result)
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    },
    checkChoice (option, answer, answers, type) {
      const check = answer
      ? option.title === answer
      : answers.includes(option.title)

      if (check) {
        if (type !== 'test') {
          return 'list-group-item-info'
        } else if (!option.correct) {
          return 'list-group-item-danger'
        } else if (option.correct) {
          return 'list-group-item-success'
        }
      }

      return null
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Feed/CandidateFeedQuestionnaireItem.vue